import { render, staticRenderFns } from "./DevComponentCards.vue?vue&type=template&id=6fc9e412&scoped=true"
import script from "./DevComponentCards.vue?vue&type=script&lang=js"
export * from "./DevComponentCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9e412",
  null
  
)

export default component.exports